import React, { useContext, useState, useEffect } from 'react';
import { AppContext } from '../App';
import { callGameServerApi, formatMoneyShorten, getInlineLoader, resolveOrientation } from '../Helpers';
import chess_pieces from '../assets/chess_pieces.png';
import cards_row from '../assets/cards_row.png';
import TopMenu from '../components/TopMenu';
import {
  AiFillDollarCircle
} from 'react-icons/ai';
import { MdOutlineNotifications, MdOutlineAccountCircle } from 'react-icons/md';
import TopBar from '../components/TopBar';
import TopBarMain from '../components/TopBarMain';
import SwipeTabs from '../components/SwipeTabs';
import CommunityChat from '../views/CommunityChat';
import { callApi } from '../Helpers';
import { BsChatDots } from 'react-icons/bs';
import OneUser from '../ones/OneUser';
import ChatMain from './ChatMain';
import ChatsIntro from './ChatsIntro';
import MainLauncher from '../components/MainLauncher';
import NewsFeed from './NewsFeed';

export default function View(props) {
  const appContext = useContext(AppContext);
  const requiredOrientation = "landscape";
  const [ ready, setReady ] = useState(false);
  const [ recentPlayers, setRecentPlayers ] = useState([]);

  const getRecentPlayers = () => {
    return new Promise(async resolve => {
      await callGameServerApi('get-recent-players', { }).then(response => {
        if(response.status === 1) {
          setRecentPlayers(response.recentPlayers);
          
        } else {
          appContext.tellError(response.msg);
        }
        resolve();
      })
    })
  }

  const init = async () => {
    await getRecentPlayers().then( async () => {
      setReady(true);
    })
  }

  useEffect(() => {
    appContext.setShowOverlayLoader(true);
    init();
  }, []);

  useEffect(() => {
    if(ready) {
      appContext.setShowOverlayLoader(false);
    }
  }, [ ready ]);

  if(appContext.auth) {
    //..
    return (
      <>
        <TopBarMain/>
        <div className='MainBody' id='_fullPane1' data-support-topbarmain={true}>
          <SwipeTabs
            support_topbarmain={true}
            tabs={[
              {
                title: "Home",
                id: "home-tab",
                view: (
                  <div className='row'>
  
                    <div 
                      className='col-md-6' 
                      style={{ 
                        padding: "10px", 
                        marginTop: "20px", 
                        backgroundImage: `url(${chess_pieces})`,
                        backgroundPosition: "center",
                        backgroundSize: "contain",
                        backgroundRepeat: "no-repeat"
                      }}
                    >
                      <div className='text-start' style={{ padding: "10px" }}>
                        
                        <div className='row'>
                          <div className='col-6 '>
                            <div className='z-depth-1 bg-dark-transparent' style={{ width: "100%", padding: "10px", height: "100%" }}>
                              <p  style={{ wordWrap: "break-word", marginRight:"10px", marginBottom:"0px", fontSize:"25px" }} className='text-start font-bold text-goldish'>
                                <span className='text-redish'>
                                  {(appContext.userData) ? formatMoneyShorten(appContext.userData.points) : 0}
                                </span>
                                <br/>
                                <span className='font-light text-muted' style={{ fontSize:"20px" }}> Points</span>
                              </p>
                            </div>
                          </div>
  
                          <div className='col-6'>
                            <div className='z-depth-1 bg-dark-transparent' style={{ width: "100%", padding: "10px", height: "100%" }}>
                              <p onClick={() => appContext.navTo({ item: 'coins_shop' })} style={{ wordWrap: "break-word", marginRight:"10px", marginBottom:"0px", fontSize:"25px", cursor: "pointer" }} className='text-start font-bold text-goldish'>
                                <span className=''>
                                  <AiFillDollarCircle className="" style={{ marginTop: "-5px", marginRight: "5px"}} />
                                  
                                  <span className=''>{(appContext.userData) ? formatMoneyShorten(appContext.userData.coins) : 0}</span>
                                </span>
                                <br/>
                                <span className='font-light text-muted' style={{ fontSize:"20px" }}> Coins</span>
                              </p>
                            </div>
                          </div>
                        </div> 
  
        
                        <div className='' style={{ padding: "0px", marginTop: "20px", width:"100%" }}>
                      
                          <div className='text-start' style={{ padding: "0px" }}>
                            <button style={{ marginLeft:"0px" }} onClick={() => appContext.navTo({ item: 'matches' })} className='btn bg-faint-black btn-rounded'>Browse Matches</button>
                            <button style={{ marginLeft:"0px" }} onClick={() => appContext.navTo({ item: 'leagues' })}  className='btn bg-faint-black btn-rounded'>Browse Leagues</button>
                            <button style={{ marginLeft:"0px" }} onClick={() => appContext.navTo({ item: 'coins_shop' })} className='btn bg-faint-black btn-rounded'>Buy coins</button>
                            <button style={{ marginLeft:"0px" }} onClick={() => appContext.navTo({ item: 'recent_users' })} className='btn bg-faint-black btn-rounded'>Discover players</button>
                            <button style={{ marginLeft:"0px" }} onClick={() => appContext.navTo({ item: 'more' })} className='btn bg-faint-black btn-rounded'>Share, Contact & More....</button>
                            <button style={{ marginLeft:"0px" }} onClick={() => appContext.navTo({ item: 'friends' })} className='btn bg-faint-black btn-rounded'>My Friends</button>
                            <button style={{ marginLeft:"0px" }} onClick={() => appContext.navTo({ item: 'new_league' })} className='btn bg-faint-black btn-rounded'>Create Paid League</button>
                          </div>
  
                          <div className='text-end' style={{ marginTop:"10px" }}>
                            <button onClick={() => appContext.navTo({ item: 'alerts' })} className='btn btn-rounded bg-bluish' style={{ width: "90px" }}>
                              <MdOutlineNotifications className='align-self-center' size={30}/><br/>
                              {
                                (appContext.userData && JSON.parse(appContext.userData.newAlerts).length > 0) ?
                                <small className='font-regular  align-self-center'>
                                  Alerts <span className='bg-redish font-bold' style={{ paddingLeft: "5px", paddingRight: "5px", borderRadius: "50%" }}>{JSON.parse(appContext.userData.newAlerts).length}</span>
                                </small>
                                :
                                <small className='font-regular align-self-center'>
                                  Alerts
                                </small>
                              }
                            </button>
  
                            <button onClick={() => appContext.navTo({ item: 'chat' })} className='btn btn-rounded bg-bluish' style={{ width: "150px", marginRight:"0px" }}>
                              <BsChatDots className='align-self-center' size={30}/><br/>
                              <small className='font-regular align-self-center'>
                                Community Chat
                              </small>
                            </button>
                          </div>
  
                        </div>
                        
                                             
                      </div>
  
                    </div>
  
                    <div 
                      className='col-md-6' 
                      style={{ 
                        padding: "10px", 
                        marginTop: "0px", 
                        backgroundImage: `url(${cards_row})`,
                        backgroundPosition: "top",
                        backgroundSize: "100%",
                        backgroundRepeat: "no-repeat"
                      }}
                    >
                      
                      <div className='d-flex justify-content-between' style={{ width: "100%", minHeight: "200px" }}>
                        <button 
                          onClick={() => appContext.navTo({ item: 'new_checkers' })} 
                          className='btn bg-dark btn-rounded font-bold align-self-center'
                          style={{
                            width: "120px",
                            height: "120px",
                            padding: "20px",
                            flexShrink: "0",
                          }}
                        >
                          New<br/>Checkers<br/>Game
                        </button>
  
                        <button 
                          onClick={() => appContext.navTo({ item: 'new_cards' })} 
                          className='btn bg-goldish btn-rounded font-bold align-self-center'
                          style={{
                            height: "120px",
                            width: "120px",
                            padding: "20px",
                            flexShrink: "0",
                          }}
                        >
                          New<br/>Cards<br/>Game
                        </button>
                      </div>
  
                    </div>
                  </div>
                )
              },
              {
                title: "Explore",
                id: "newsfeed-tab",
                view: (
                  <NewsFeed/>
                )
              },
              {
                title: "Chats",
                id: "chat-tab",
                view: (
                  <ChatsIntro/>
                )
              }
            ]}
          />
        </div>
      </>
    )
    //..
  } else {
    return (
      <MainLauncher/>
    )
  }

  
}
